<template>
  <div ref="blackListClientsTab">
    <div class="tw-text-forTitle" style="max-height: 560px; min-height: 560px">
      <BaseLoader v-if="loadingState"></BaseLoader>

      <div class="tw-flex tw-gap-[10px]">
        <div ref="clients__is_blacklisted" v-if="!loadingState">
          <BaseCheckboxV2
            input-name="clients__is_blacklisted"
            v-model="dataForTab.clients__is_blacklisted"
            signClass="tw-text-[12px] tw-text-forTitle"
            @oncheckeds="(data) => updateValue(data, true)"
            >{{ dataLang["clients_register_text_14"] }}</BaseCheckboxV2
          >
        </div>

        <div class="">
          <BaseCheckboxV2
            input-name="gchs"
            v-model="gchs"
            signClass="tw-text-[12px] tw-text-forTitle"
            disabled
            >{{ dataLang["clients_register_text_175"] }}</BaseCheckboxV2
          >
        </div>
      </div>

      <div v-if="showData && !loadingState" class="tw-mt-[8px]">
        <div ref="clients__blacklist_comment">
          <BaseInputNew
            class="tw-whitespace-nowrap tw-text-forTitle"
            inputClass="tw-app-input-type-2"
            input-name="clients__blacklist_comment"
            @input="updateValue"
            :horizontalTitle="true"
            :value="dataForTab.clients__blacklist_comment"
            :name-sign="dataLang['clients_register_text_87']"
          >
          </BaseInputNew>
        </div>

        <div
          class="tw-mt-[8px] tw-text-[11px] tw-flex tw-gap-[10px]"
          v-if="dataForTab.clients__balance < 0"
        >
          <div>{{ dataLang["clients_register_text_88"] }}:</div>
          <div class="tw-font-[600]">
            {{ dataForTab.clients__balance.replace(".", ",") }}
          </div>
        </div>

        <div class="tw-text-[11px] tw-mt-[8px]">
          {{ dataLang["clients_register_text_89"] }}
        </div>

        <div class="tw-mt-[8px] tw-flex tw-gap-[10px]">
          <UploadFileWithPreview
            style="height: 109px; width: 109px"
            v-for="(item, index) of galleryData"
            :key="item.client_blacklist_gallery__id"
            :file-preview="item.client_blacklist_gallery__file"
            accept="image/png,image/jpg,image/jpeg"
            :max-weight="10000"
            :max-x-size="1000"
            :max-y-size="750"
            preview="image.svg"
            @clickOnImage="clickOnImage(index)"
            :additionalParams="{ keyData: index }"
            type-of-form-data="clientDoc"
            :error-message-max-weight="dataLang['error_message_max_file_size']"
            classes="file-load--gallery"
            @load-file="(params) => loadfile(params)"
            @remove-file="(params) => removefile(params)"
          />
        </div>

        <div class="tw-bg-[#DCE0ED] tw-p-[15px] tw-mt-[8px]">
          <div ref="clients__is_wanted" class="">
            <BaseCheckboxV2
              signClass="tw-text-[12px] tw-text-forTitle"
              placeholder=""
              input-name="clients__is_wanted"
              v-model="dataForTab.clients__is_wanted"
              @oncheckeds="updateValue"
            >
              {{ dataLang["clients_register_text_91"] }}
            </BaseCheckboxV2>
            <div class="tw-mt-[10px] tw-text-forText tw-text-[12px]">
              {{ dataLang["clients_register_text_92"] }}
            </div>
          </div>
        </div>

        <div
          class="tw-bg-[#F1F3F5] tw-p-[15px] tw-text-forText tw-text-[12px] tw-mt-[8px] tw-flex tw-gap-[10px]"
          v-if="
            dataForTab.clients__balance < 0 ||
            dataForTab.clients__is_blacklisted == 1
          "
        >
          <img
            :src="require(`@/assets/icons/danger.svg`)"
            width="22"
            height="22"
          />
          <div>
            <div class="tw-text-danger tw-mt-[2px]">
              {{ dataLang["clients_register_text_93"] }}
            </div>
            <div class="tw-mt-[8px]">
              {{ dataLang["clients_register_text_94"] }}
            </div>
          </div>
        </div>
        <gallery
          :images="images"
          :index="index"
          @close="index = null"
        ></gallery>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
.rating-table {
  width: 100%;
  font-size: 12px;

  & tr:first-child {
    font-weight: 500;

    td {
    }
  }

  & tr:nth-child(2n + 1) {
    background-color: #f5f5f5;
  }

  & td {
    padding: 16px 10px;
    text-align: center;
    border: 1px solid #cacaca;
  }
}
</style>

<script>
import { mapActions, mapState, mapMutations, mapGetters } from "vuex";
import GeneralService from "@/api/GeneralService";
import VueGallery from "vue-gallery";
import EventBus from "@/event-bus";
import UploadFileWithPreview from "@/components/UploadFileWithPreview.vue";
import StorageFileService from "@/api/StorageFileService";
export default {
  components: {
    UploadFileWithPreview,
    gallery: VueGallery,
  },
  props: {
    modeOpenModal: {
      type: String,
      default: "create",
    },
    modalInfo: {
      type: Object,
    },
    currentOpenedId: {
      type: Number,
    },
  },
  data() {
    return {
      showData: false,
      loadingState: true,
      tabInfo: this.modalInfo,
      currentRayting: 0,
      dataForTab: {},
      dataForEmit: {},
      images: [],
      sendImage: [],
      index: null,
      galleryData: [],
      timeout: null,
      gchs: false,
    };
  },
  methods: {
    sendData(callback, nameTab, oldTab, newTab, flagIsClose) {
      this.loadingState = true;
      if (Object.keys(this.dataForEmit).length) {
        GeneralService.edit(`/clients/${this.modalInfo.id}`, this.dataForEmit)
          .then((data) => {
            this.$toast.success(data.data.message);
            callback(true, nameTab, oldTab, newTab, flagIsClose);
          })
          .catch((err) => {
            this.$toast.success(err.response.data.message);
            callback(false, nameTab, oldTab, newTab, flagIsClose);
          });
      } else {
        callback(true, "", oldTab, newTab, flagIsClose);
      }
      // callback(true, nameTab, oldTab, newTab, flagIsClose)
    },
    clickOnImage(index) {
      this.index = index;
      console.log(this.index, index);
    },
    loadfile(params) {
      this.loadingState = true;
      params.fileInFormData.append("type", "client_blacklist");
      StorageFileService.upload(params.fileInFormData)
        .then((data) => {
          let result = data.data.data.url;
          this.galleryData[params.keyData].client_blacklist_gallery__file =
            data.data.data.id;
          this.images[params.keyData] = data.data.data.id;
          GeneralService.edit(`/clients/${this.modalInfo.id}`, {
            clients__blacklist_gallery: [this.galleryData[params.keyData]],
          }).then((data) => {
            console.log("SAVE GALLERY DATA |||", this.galleryData);

            this.$toast.success(data.data.message);
            this.images[params.keyData] = result;
            this.loadMainInfo();
          });
        })
        .catch((err) => {
          this.$toast.error(err.response.data.message, { duration: 5000 });
        });
    },
    removefile(params) {
      this.loadingState = true;
      this.galleryData[params.keyData].client_blacklist_gallery__file = "";
      this.images[params.keyData] = "";
      GeneralService.edit(`/clients/${this.modalInfo.id}`, {
        clients__blacklist_gallery: this.galleryData,
      }).then((data) => {
        this.$toast.success(data.data.message);
        this.loadMainInfo();
        this.loadingState = false;
      });
    },

    updateValue(data, flag) {
      this.dataForEmit[data.name] = data.value;
      this.$refs[data.name].classList.remove("input-error");
      if (flag) {
        GeneralService.edit(`/clients/${this.modalInfo.id}`, {
          ...this.dataForEmit,
        })
          .then((data) => {
            this.showData = !this.showData;
            this.$toast.success(data.data.message);
            EventBus.$emit("updateMainModalComponent");
          })
          .catch((err) => {
            this.$toast.error(err.response.data.message, { duration: 5000 });
          });
      }
      if (data.name == "clients__blacklist_comment") {
        clearTimeout(this.timeout);
        this.timeout = setTimeout(() => {
          GeneralService.edit(`/clients/${this.modalInfo.id}`, {
            clients__blacklist_comment: data.value,
          })
            .then((data) => {
              this.$toast.success(data.data.message);
            })
            .catch((err) => {
              this.$toast.success(err.response.data.message);
            });
        }, 700);
      }
    },

    loadMainInfo() {
      this.loadingState = true;
      GeneralService.get(
        `/clients/${this.tabInfo.id}?joins=client_blacklist_gallery`
      )
        .then((data) => {
          this.dataForTab = data.data.data.rows[0];
          this.showData = data.data.data.rows[0].clients__is_blacklisted;
          this.gchs = this.dataForTab.clients__balance < 0;
          this.galleryData = data.data.data.rows[0].clients__blacklist_gallery;
          this.galleryData.forEach((element, index) => {
            if (element.client_blacklist_gallery__file) {
              this.images.push(element.client_blacklist_gallery__file);
            } else {
              this.images.push("");
            }
          });
          this.loadingState = false;
        })
        .catch((e) => {});
    },
  },
  created() {
    this.loadMainInfo();
  },
  computed: {
    ...mapState("translationModule", ["dataLang"]),
  },
};
</script>
